import { Component, ErrorInfo, ReactNode } from 'react';

interface Props {
  children: ReactNode;
}

interface State {
  hasError: boolean;
  error: Error | null;
  componentStack: string | null;
}

export class ErrorBoundary extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = { hasError: false, error: null, componentStack: null };
  }

  static getDerivedStateFromError(error: Error): Partial<State> {
    return { hasError: true, error };
  }

  componentDidCatch(error: Error, info: ErrorInfo) {
    console.error('[ErrorBoundary] ===== REACT CRASH REPORT =====');
    console.error('[ErrorBoundary] Error message:', error.message);
    console.error('[ErrorBoundary] Error stack:', error.stack);
    console.error('[ErrorBoundary] Component tree:', info.componentStack);
    this.setState({ componentStack: info.componentStack ?? null });
  }

  render() {
    if (this.state.hasError) {
      return (
        <div style={{ padding: 24, fontFamily: 'monospace', maxWidth: 900 }}>
          <h2 style={{ color: 'red' }}>Application Error (Diagnostic Build)</h2>
          <p style={{ color: '#666', fontSize: 13 }}>
            Open DevTools → Console to see the full crash report including component tree.
          </p>
          <h3>Error</h3>
          <pre style={{ whiteSpace: 'pre-wrap', background: '#fee', padding: 12, borderRadius: 4, fontSize: 12 }}>
            {this.state.error?.message}
          </pre>
          {this.state.componentStack && (
            <>
              <h3>Component Tree at Crash</h3>
              <pre style={{ whiteSpace: 'pre-wrap', background: '#f5f5f5', padding: 12, borderRadius: 4, fontSize: 12 }}>
                {this.state.componentStack}
              </pre>
            </>
          )}
          <button
            onClick={() => window.location.assign('/')}
            style={{ marginTop: 16, padding: '8px 16px', cursor: 'pointer' }}
          >
            Reload
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}
